import React from 'react';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { Icon, IconType, SVG } from 'components/tokens/Icon';
import Symbol from 'assets/logotype/symbol.svg';
import useMediaQuery from 'utils/useMediaQuery';
import { arrowRight } from 'icons/default';
import { Colors } from 'enums/Colors';
import { ScrollableModal } from 'components/ScrollableModal';

import styles from './ColorBox.module.scss';

interface IListItem {
  symbol: SVG;
  item: JSX.Element;
}

interface IColorBoxButtons {
  text: string;
  href?: string;
  scrollableModalContent?: React.ReactNode;
  dataLayerEvent?: any;
}

interface Props {
  color: Colors;
  title: string;
  list: IListItem[];
  text: JSX.Element;
  modalContentCenter?: boolean;
  buttons?: Array<IColorBoxButtons>;
}

export const ColorBox: React.FC<Props> = ({
  color,
  title,
  list,
  text,
  modalContentCenter = false,
  buttons = [],
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className={styles.wrapper} style={{ backgroundColor: `var(--color-${color})` }}>
      {!isMobile && <Symbol className={styles.symbol} />}
      <h2>{title}</h2>
      <div className={styles.inner}>
        <ul className={styles.list}>
          {list.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={title + i}>
              {item.symbol && <Icon icon={item.symbol} size={36} type={IconType.Stroke} />}
              <div className={styles['item-rows']}>{item.item}</div>
            </li>
          ))}
        </ul>
        <div className={styles['text-button']}>
          {text}
          <div className={styles.buttons}>
            {buttons?.length
              ? buttons.map((buttonItem) =>
                  typeof window !== 'undefined' && buttonItem.scrollableModalContent ? (
                    <ScrollableModal
                      key={buttonItem.text}
                      buttonContent={buttonItem.text}
                      title="INFORMATION"
                      buttonVariant={ButtonVariant.Primary}
                      contentVertCenter={modalContentCenter}
                    >
                      {buttonItem.scrollableModalContent}
                    </ScrollableModal>
                  ) : (
                    <Button
                      key={buttonItem.text}
                      type={ButtonType.Button}
                      href={buttonItem.href}
                      variant={ButtonVariant.Primary}
                      size={ButtonSize.Large}
                      trailingIcon={!isMobile ? arrowRight : undefined}
                      dataLayerEvent={buttonItem.dataLayerEvent}
                    >
                      {buttonItem.text}
                    </Button>
                  )
                )
              : null}
          </div>
        </div>
      </div>
    </div>
  );
};
